{
  "schema_version": 1,
  "task_id": "L5-PLUGIN-ECOSYSTEM-READONLY-CATALOG-001",
  "status": "readonly-catalog-only",
  "source_boundary_ref": "config/l5-sync-ecosystem-boundary.json#plugin-ecosystem",
  "authority_boundary": {
    "catalog_only": true,
    "formal_gate_replacement": false,
    "plugin_install": false,
    "plugin_connect": false,
    "oauth_flow": false,
    "network_access": false,
    "code_download": false,
    "unknown_code_execution": false,
    "external_write": false,
    "secret_storage": false,
    "model_call": false,
    "runtime_activation": false,
    "paid_action": false,
    "task_completion_authority": false
  },
  "allowed_now": [
    "local_catalog_review",
    "license_metadata_note",
    "permission_envelope_design",
    "capability_capsule_planning",
    "future_task_planning"
  ],
  "forbidden_now": [
    "install_plugin",
    "connect_account",
    "start_oauth",
    "download_code",
    "execute_unknown_code",
    "store_secret",
    "write_external_system",
    "deploy_or_publish",
    "send_message",
    "create_issue_or_pr",
    "paid_action"
  ],
  "future_activation_controls": [
    "explicit_user_approval",
    "task_spec",
    "license_review",
    "permission_envelope",
    "secret_boundary",
    "capability_capsule",
    "observable_run_protocol",
    "terminal_receipt",
    "evidence_bundle",
    "independent_reviewer",
    "rollback_plan"
  ],
  "candidate_classes": [
    {
      "id": "codex-installed-skills",
      "label": "Installed Codex skills and local project skills",
      "policy": "catalog as known local affordances only; skill instructions can guide work but cannot grant new authority"
    },
    {
      "id": "recommended-plugins-not-installed",
      "label": "Recommended plugins not installed",
      "policy": "catalog only; user-facing install/connect remains a separate explicit task"
    },
    {
      "id": "github-open-source-reference",
      "label": "GitHub/open-source reference projects",
      "policy": "read-only source and license research only; no clone, install, build or execution"
    },
    {
      "id": "ide-and-design-surfaces",
      "label": "IDE/design/deployment surfaces",
      "policy": "surface planning only; no project-external writes or design-file mutations without a task"
    }
  ],
  "candidates": [
    {
      "id": "codex-github-plugin",
      "name": "GitHub plugin",
      "source_type": "installed_skill_or_plugin",
      "category": "source-control",
      "source_ref": "github@openai-curated-remote",
      "current_state": "available-in-session-cataloged",
      "maturity": "C1",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Use provider/plugin terms and repository-specific licenses for source content."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "A future GitHub action task must define repo scope, read/write split, token boundary, Evidence, independent Reviewer and rollback.",
      "rollback": "Disconnect/uninstall plugin if later connected; revert any task-scoped repository mutations.",
      "risk": "repository write/issue/PR actions could become external writes if not separated"
    },
    {
      "id": "codex-figma-plugin",
      "name": "Figma plugin",
      "source_type": "installed_skill_or_plugin",
      "category": "design",
      "source_ref": "figma@openai-curated-remote",
      "current_state": "available-in-session-cataloged",
      "maturity": "C1",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Design files and generated assets need task-specific ownership/licensing notes."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "A future design handoff task must define target file, edit scope, asset ownership, Evidence, Reviewer and rollback.",
      "rollback": "Use Figma version history or delete task-created design artifacts if later activated.",
      "risk": "design-file writes and asset ownership can drift without explicit scope"
    },
    {
      "id": "codex-cloudflare-skills",
      "name": "Cloudflare / Wrangler skills",
      "source_type": "installed_skill",
      "category": "deployment",
      "source_ref": "cloudflare, wrangler, workers-best-practices skills",
      "current_state": "available-in-session-cataloged",
      "maturity": "C1",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Cloudflare services, Workers, Pages, D1/KV/R2 and Wrangler each retain provider terms."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Any deploy, DNS, Secret or Cloudflare data-plane action needs a task-scoped Cloudflare Evidence bundle, independent Reviewer and rollback.",
      "rollback": "Cloudflare previous deployment/DNS rollback plus Git revert for task files.",
      "risk": "deployment and DNS actions are external writes with public impact"
    },
    {
      "id": "codex-vercel-skills",
      "name": "Vercel AI/UI/deployment skills",
      "source_type": "installed_skill",
      "category": "frontend-ai-platform",
      "source_ref": "vercel:* skills",
      "current_state": "available-in-session-cataloged",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Vercel platform, AI SDK and component-library licensing must be checked per adoption."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Use as reference until an explicit dependency/deploy task reviews license, lockfile, Evidence, Reviewer and rollback.",
      "rollback": "Remove adopted package/config and revert deployment if later activated.",
      "risk": "UI/deployment convenience can hide new runtime and hosting authority"
    },
    {
      "id": "codex-browser-playwright-skills",
      "name": "Browser / Chrome / Playwright skills",
      "source_type": "installed_skill",
      "category": "browser-automation",
      "source_ref": "browser, chrome, playwright, web-perf skills",
      "current_state": "available-in-session-cataloged",
      "maturity": "C1",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Browser automation outputs are evidence inputs, not formal authority."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "UI verification tasks must define profile boundary, allowed URLs, screenshot/log Evidence, Reviewer, rollback and no-account-write policy.",
      "rollback": "Close browser automation session and delete task-local artifacts.",
      "risk": "browser control can mutate accounts if URL/action boundaries are vague"
    },
    {
      "id": "recommended-google-drive",
      "name": "Google Drive plugin",
      "source_type": "recommended_plugin_not_installed",
      "category": "cloud-storage",
      "source_ref": "google-drive@openai-curated-remote",
      "current_state": "available-not-installed",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Requires Google account/OAuth approval and data-boundary review before use."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future cloud sync task must define OAuth scope, file/folder scope, conflict policy, Evidence, Reviewer and rollback.",
      "rollback": "Disconnect plugin/OAuth grant; remove any task-created mirror metadata.",
      "risk": "cloud document reads/writes and OAuth scopes can exceed project boundary"
    },
    {
      "id": "recommended-notion",
      "name": "Notion plugin",
      "source_type": "recommended_plugin_not_installed",
      "category": "knowledge-base",
      "source_ref": "notion@openai-curated-remote",
      "current_state": "available-not-installed",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Workspace authorization and page/database scope require explicit user decision."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future Notion task must define workspace/page scope, read/write split, Evidence, Reviewer and rollback.",
      "rollback": "Revoke integration and delete task-created pages/databases if any.",
      "risk": "workspace knowledge may contain non-project personal data"
    },
    {
      "id": "recommended-slack-teams",
      "name": "Slack / Teams plugins",
      "source_type": "recommended_plugin_not_installed",
      "category": "messaging",
      "source_ref": "slack@openai-curated-remote, teams@openai-curated-remote",
      "current_state": "available-not-installed",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Messaging actions are external communications and require explicit approval."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future messaging task must define channels, recipients, draft/approval flow, Evidence, Reviewer and rollback limits.",
      "rollback": "Disconnect plugin; messages cannot be fully rolled back, so send actions need explicit approval.",
      "risk": "irreversible external communication"
    },
    {
      "id": "recommended-atlassian-rovo",
      "name": "Atlassian Rovo plugin",
      "source_type": "recommended_plugin_not_installed",
      "category": "work-management",
      "source_ref": "atlassian-rovo@openai-curated-remote",
      "current_state": "available-not-installed",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Jira/Confluence/Rovo scopes and workspace data policy must be reviewed."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future Atlassian task must define project scope, issue/page write boundaries, Evidence, Reviewer and rollback.",
      "rollback": "Disconnect plugin; revert task-created issues/pages where possible.",
      "risk": "work-management writes affect team records"
    },
    {
      "id": "recommended-box-sharepoint-outlook",
      "name": "Box / SharePoint / Outlook plugins",
      "source_type": "recommended_plugin_not_installed",
      "category": "enterprise-storage-email-calendar",
      "source_ref": "box, sharepoint, outlook-email, outlook-calendar plugins",
      "current_state": "available-not-installed",
      "maturity": "C0",
      "license": {
        "status": "provider_terms_apply",
        "notes": "Enterprise identity, mail and file scopes require explicit account approval."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future enterprise connector task must define data scope, legal/privacy boundary, Evidence, Reviewer and rollback.",
      "rollback": "Disconnect plugin; email/calendar sends are irreversible and need explicit approval.",
      "risk": "private enterprise data and irreversible messages/calendar changes"
    },
    {
      "id": "open-source-repomix",
      "name": "Repomix context-pack pattern",
      "source_type": "github_open_source_reference",
      "category": "context-compression",
      "source_ref": "config/open-source-acceleration.json#repomix",
      "current_state": "reference-only",
      "maturity": "C1",
      "license": {
        "status": "requires_repository_specific_review",
        "notes": "Already treated as workflow-reference; no CLI adoption in this task."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Any CLI/package adoption requires a task, lockfile, license, Evidence, Reviewer and rollback.",
      "rollback": "Remove adopted dependency/config if later added.",
      "risk": "context packs can accidentally include secrets or build artifacts"
    },
    {
      "id": "open-source-nextest-cargo-deny",
      "name": "cargo-nextest / cargo-deny gate references",
      "source_type": "github_open_source_reference",
      "category": "devx-gates",
      "source_ref": "config/open-source-acceleration.json#cargo-nextest,cargo-deny",
      "current_state": "canary-or-policy-reference",
      "maturity": "C1",
      "license": {
        "status": "requires_repository_specific_review",
        "notes": "Gate acceleration cannot replace formal G3/H1 authority without equivalence proof."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "A future gate-tools task must prove hermeticity, receipt equivalence, Evidence, Reviewer and rollback.",
      "rollback": "Remove tool config/dependencies and revert gate wiring.",
      "risk": "fast gates can be mistaken for formal gate authority"
    },
    {
      "id": "open-source-tauri-v2",
      "name": "Tauri v2 desktop shell reference",
      "source_type": "github_open_source_reference",
      "category": "desktop-shell",
      "source_ref": "config/open-source-acceleration.json#tauri-v2",
      "current_state": "front-end-adr-candidate",
      "maturity": "C1",
      "license": {
        "status": "requires_repository_specific_review",
        "notes": "Desktop shell is Experience OS plane, not AIOS Kernel/Runtime authority."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Future Tauri adoption needs a task, command ACL, IPC policy, local smoke, Evidence, Reviewer and rollback.",
      "rollback": "Revert shell files/config; keep Kernel authority outside Tauri.",
      "risk": "desktop IPC can become a system-level write path if not default-deny"
    },
    {
      "id": "open-source-mcp-reference",
      "name": "MCP reference servers and agent tools",
      "source_type": "github_open_source_reference",
      "category": "tool-bus",
      "source_ref": "config/open-source-acceleration.json#mcp-reference-servers",
      "current_state": "architecture-reference",
      "maturity": "C0",
      "license": {
        "status": "requires_repository_specific_review",
        "notes": "Reference-only until each server/tool is individually audited."
      },
      "permission_envelope": {
        "current_enabled": false,
        "read_only_by_default": true,
        "can_install": false,
        "can_connect": false,
        "can_execute": false,
        "can_write": false,
        "can_deploy": false,
        "can_send_messages": false,
        "can_store_secrets": false
      },
      "admission_gate": "Every MCP server task needs a Capsule, permission manifest, isolated smoke, Evidence, Reviewer and rollback.",
      "rollback": "Remove server manifest/config and revoke credentials if ever connected.",
      "risk": "MCP servers can hide broad file, network or account authority"
    }
  ],
  "summary": {
    "candidate_count": 14,
    "recommended_not_installed_count": 5,
    "installed_or_available_skill_count": 5,
    "open_source_reference_count": 4,
    "default_enabled_count": 0,
    "installable_now_count": 0,
    "connectable_now_count": 0,
    "executable_now_count": 0,
    "external_write_now_count": 0
  }
}
